/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import GenericTooltip from "@ui-components/Tooltip/GenericTooltip";
import React from "react";

export interface DatacenterConnection {
	id: number;
	subId: string;
	datacenterIdSource: string;
	hardwareIdSource: number | null;
	portIdSource: number | null;
	capacityMbps: number;
	connectionType: string;
	datacenterIdDest?: string | number | null;
	datacenterSource?: any | null;
	hardwareSource?: any | null;
	portSource?: any | null;
	hardwareIdDest?: number | null;
	portIdDest?: number | null;
	datacenterDest?: any | null;
	hardwareDest?: any | null;
	portDest?: any | null;
	metadata?: object;
	createdAt?: string;
	updatedAt?: string;
}

export const columns: GenericTableColumn<DatacenterConnection>[] = [
	{
		header: "Subscription ID",
		accessor: "subId",
	},
	{
		header: "Source Datacenter",
		accessor: "datacenterIdSource",
	},
	{
		header: "Destination Datacenter",
		renderCell: (row: DatacenterConnection) => {
			return row.datacenterIdDest || "-";
		},
	},
    {
		header: "Source Hardware",
		renderCell: (row: DatacenterConnection) => {
			return row.hardwareSource?.hostname || "-";
		},
	},
	{
		header: "Destination Hardware",
		renderCell: (row: DatacenterConnection) => {
			return row.hardwareDest?.hostname || "-";
		},
	},
    {
		header: "Source Port",
		renderCell: (row: DatacenterConnection) => {
			const portNumber = row.portSource?.portNumber;
			const portDescription = row.portSource?.portDescription;
			
			if (!portNumber) {
				return "-";
			}
			
			if (portDescription) {
				return (
					<GenericTooltip text={portDescription} position="top">
						<span className="cursor-pointer underline decoration-dotted">
							{portNumber}
						</span>
					</GenericTooltip>
				);
			}
			
			return <span>{portNumber}</span>;
		},
	},
	{
		header: "Destination Port",
		renderCell: (row: DatacenterConnection) => {
			const portNumber = row.portDest?.portNumber;
			const portDescription = row.portDest?.portDescription;
			
			if (!portNumber) {
				return "-";
			}
			
			if (portDescription) {
				return (
					<GenericTooltip text={portDescription} position="top">
						<span className="cursor-pointer underline decoration-dotted">
							{portNumber}
						</span>
					</GenericTooltip>
				);
			}
			
			return <span>{portNumber}</span>;
		},
	},
	{
		header: "Capacity (Mbps)",
		accessor: "capacityMbps",
	},
	{
		header: "Connection Type",
		accessor: "connectionType",
	},
	{
		header: "Actions",
		accessor: "id",
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* Actions will be overridden in DatacenterConnectionsPage.tsx */}
			</div>
		),
	},
];
